export const laptopProductForHome=[
    {
        "no": 1,
        "id": "ca",
        "productname": "hp 250 g8",
        "productprice": 325000,
        "productinfo": "hp 250 g8 10th generation laptop",
        "productimage1": "/skydome images/hp-250-g8-img1.jpeg",
        "productimage2": "/skydome images/hp-250-g8-img2.jpeg",
        "processortype": "intel",
        "processorname": "corei7",
        "quantity":1,
        "brand": "hp",
        "batteryinfo": "45watt li-on battery",
        "ram": "8gb",
        "rom": "1tbhdd",
        "windowversion": "windows 10 pro",
        "color": "silver",
        "touchscreen": "no",
        "netweight": "1.3kg",
        "inch": "15",
        "gaminggraphics": "2gb dedicated gaming graphics",
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"hp 250 g8 laptop 8gb ram 1tb hdd windows 10pro core i5"
	
    },
    {
        "no": 3,
        "id": "cb",
        "productname": "lenovo legion 5",
        "productprice": 650000,
        "productinfo": "lenovo legion 5 15IMH05 10th generation laptop",
        "productimage1": "/skydome images/lenovo-legion-5-img1.png",
        "productimage2": "/skydome images/lenovo-legion-5-img2.jpeg",
        "processortype": "intel",
        "processorname": "corei7",
        "quantity":1,
        "brand": "lenovo",
        "batteryinfo": "integrated 60Wh",
        "ram": "8gb",
        "rom": "512gb ssd",
        "windowversion": "windows 10 home",
        "color": "black",
        "touchscreen": "no",
        "netweight": "1.3kg",
        "inch": "15.6",
        "gaminggraphics": "NVIDIA GTX 4GB GDDR6",
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"lenovo legion 5 core i5 8gb ram 512gb 4gb nivida win..."
    },
    {
        "no": 4,
        "id": "cc",
        "productname": "mac book pro",
        "productprice": 1395000,
        "productinfo": "apple mac book pro 16\" AMD Raedon Pro 5500M",
        "productimage1": "/skydome images/mac-book-pro-img2.jpeg",
        "productimage2": "/skydome images/mac-book-pro-img1.jpeg",
        "processortype": "intel",
        "processorname": "corei9",
        "quantity":1,
        "brand": "Apple",
        "batteryinfo": "96W USB-C power adapter Up to 11 hours battery life",
        "ram": "16gb",
        "rom": "1tb ssd",
        "windowversion": "mac os",
        "color": "space grey",
        "touchscreen": "no",
        "netweight": "2kg",
        "inch": "14.09",
        "gaminggraphics": "AMD Radeon Pro 5500M graphics card With 4GB of GDDR6 VRAM",
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"apple mac book pro touch bar core i9 16gb 1tb ssd AMD..."
    },
    {
        "no": 6,
        "id": "cd",
        "productname": "acer predator helios",
        "productprice": 810000,
        "productinfo": "acer predator helios 300",
        "productimage1": "/skydome images/acer-predator-helios-img2.jpeg",
        "productimage2": "/skydome images/acer-predator-helios-img1.jpeg",
        "processortype": "intel",
        "processorname": "corei7",
        "quantity":1,
        "brand": "Acer",
        "batteryinfo": "Average Battery Life (in hours) ?6 Hours",
        "ram": "16gb",
        "rom": "512gb ssd",
        "windowversion": "windows 10",
        "color": "black",
        "touchscreen": "no",
        "netweight": "2.5kg",
        "inch": "15.6",
        "gaminggraphics": "Dedicated NVIDIA GeForce RTX 3060 6GB",
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"acer predator helios 300 corei7 16gb ram,..."
    }
]